var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--blue" }, [
    _c("div", { staticClass: "c-survey__content c-survey__content--padding" }, [
      _c(
        "div",
        {
          staticClass:
            "c-survey__remaining-tokens-wrapper c-survey__remaining-tokens-wrapper--mobile",
        },
        [
          _c("div", { staticClass: "c-survey__remaining-tokens white-text" }, [
            _c("h1", [_vm._v(_vm._s(_vm.getRemainingTokens))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-survey__remaining-tokens-text white-text" },
            [_vm._v("total remaining tokens")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("main", {
        staticClass: "c-survey__html",
        domProps: { innerHTML: _vm._s(_vm.pageThree.content) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-survey__grid c-survey__grid--page-three" }, [
        _c(
          "div",
          { staticClass: "c-survey__grid c-survey__grid--page-three-tokens" },
          [
            _c("div", { staticClass: "c-survey__page-three--spacer" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "c-survey__remaining-tokens-wrapper c-survey__remaining-tokens-wrapper--desktop",
              },
              [
                _c(
                  "div",
                  { staticClass: "c-survey__remaining-tokens white-text" },
                  [_c("h1", [_vm._v(_vm._s(_vm.getRemainingTokens))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-survey__remaining-tokens-text white-text" },
                  [_vm._v("total remaining tokens")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-survey__section-summary",
                style: {
                  backgroundColor: _vm.sections.sectionOne.sectionColour,
                },
              },
              [
                _c("h3", { staticClass: "white-text" }, [
                  _vm._v(_vm._s(_vm.sections.sectionOne.label)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "white-text" }, [
                  _vm._v(_vm._s(_vm.sections.sectionOne.shortDescription)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "c-survey__token-buttons c-survey__token-buttons--mobile",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "c-survey__token-button",
                        class: {
                          "c-survey__token-button--disabled":
                            _vm.isRemoveButtonDisabled("sectionOneTokens"),
                        },
                        style: {
                          backgroundColor: _vm.isRemoveButtonDisabled(
                            "sectionOneTokens"
                          )
                            ? "#bcbec0"
                            : _vm.sections.sectionOne.sectionColour,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.updateTokens("sectionOneTokens", -1)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "c-survey__icon c-survey__icon--minus",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass:
                          "c-survey__token-allocation-count white-text",
                      },
                      [_vm._v(_vm._s(_vm.submissionData.sectionOneTokens))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "c-survey__token-button",
                        class: {
                          "c-survey__token-button--disabled":
                            _vm.isAddButtonDisabled,
                        },
                        style: {
                          backgroundColor: _vm.isAddButtonDisabled
                            ? "#bcbec0"
                            : _vm.sections.sectionOne.sectionColour,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.updateTokens("sectionOneTokens", 1)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "c-survey__icon c-survey__icon--plus",
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "c-survey__token-buttons c-survey__token-buttons--desktop",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-survey__token-button",
                    class: {
                      "c-survey__token-button--disabled":
                        _vm.isRemoveButtonDisabled("sectionOneTokens"),
                    },
                    style: {
                      backgroundColor: _vm.isRemoveButtonDisabled(
                        "sectionOneTokens"
                      )
                        ? "#bcbec0"
                        : _vm.sections.sectionOne.sectionColour,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateTokens("sectionOneTokens", -1)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "c-survey__icon c-survey__icon--minus",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    staticClass: "c-survey__token-allocation-count white-text",
                  },
                  [_vm._v(_vm._s(_vm.submissionData.sectionOneTokens))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "c-survey__token-button",
                    class: {
                      "c-survey__token-button--disabled":
                        _vm.isAddButtonDisabled,
                    },
                    style: {
                      backgroundColor: _vm.isAddButtonDisabled
                        ? "#bcbec0"
                        : _vm.sections.sectionOne.sectionColour,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateTokens("sectionOneTokens", 1)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "c-survey__icon c-survey__icon--plus",
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-survey__section-summary",
                style: {
                  backgroundColor: _vm.sections.sectionTwo.sectionColour,
                },
              },
              [
                _c("h3", { staticClass: "white-text" }, [
                  _vm._v(_vm._s(_vm.sections.sectionTwo.label)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "white-text" }, [
                  _vm._v(_vm._s(_vm.sections.sectionTwo.shortDescription)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "c-survey__token-buttons c-survey__token-buttons--mobile",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "c-survey__token-button",
                        class: {
                          "c-survey__token-button--disabled":
                            _vm.isRemoveButtonDisabled("sectionTwoTokens"),
                        },
                        style: {
                          backgroundColor: _vm.isRemoveButtonDisabled(
                            "sectionTwoTokens"
                          )
                            ? "#bcbec0"
                            : _vm.sections.sectionTwo.sectionColour,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.updateTokens("sectionTwoTokens", -1)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "c-survey__icon c-survey__icon--minus",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass:
                          "c-survey__token-allocation-count white-text",
                      },
                      [_vm._v(_vm._s(_vm.submissionData.sectionTwoTokens))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "c-survey__token-button",
                        class: {
                          "c-survey__token-button--disabled":
                            _vm.isAddButtonDisabled,
                        },
                        style: {
                          backgroundColor: _vm.isAddButtonDisabled
                            ? "#bcbec0"
                            : _vm.sections.sectionTwo.sectionColour,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.updateTokens("sectionTwoTokens", 1)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "c-survey__icon c-survey__icon--plus",
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "c-survey__token-buttons c-survey__token-buttons--desktop",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-survey__token-button",
                    class: {
                      "c-survey__token-button--disabled":
                        _vm.isRemoveButtonDisabled("sectionTwoTokens"),
                    },
                    style: {
                      backgroundColor: _vm.isRemoveButtonDisabled(
                        "sectionTwoTokens"
                      )
                        ? "#bcbec0"
                        : _vm.sections.sectionTwo.sectionColour,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateTokens("sectionTwoTokens", -1)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "c-survey__icon c-survey__icon--minus",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    staticClass: "c-survey__token-allocation-count white-text",
                  },
                  [_vm._v(_vm._s(_vm.submissionData.sectionTwoTokens))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "c-survey__token-button",
                    class: {
                      "c-survey__token-button--disabled":
                        _vm.isAddButtonDisabled,
                    },
                    style: {
                      backgroundColor: _vm.isAddButtonDisabled
                        ? "#bcbec0"
                        : _vm.sections.sectionTwo.sectionColour,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateTokens("sectionTwoTokens", 1)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "c-survey__icon c-survey__icon--plus",
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-survey__section-summary",
                style: {
                  backgroundColor: _vm.sections.sectionThree.sectionColour,
                },
              },
              [
                _c("h3", { staticClass: "white-text" }, [
                  _vm._v(_vm._s(_vm.sections.sectionThree.label)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "white-text" }, [
                  _vm._v(_vm._s(_vm.sections.sectionThree.shortDescription)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "c-survey__token-buttons c-survey__token-buttons--mobile",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "c-survey__token-button",
                        class: {
                          "c-survey__token-button--disabled":
                            _vm.isRemoveButtonDisabled("sectionThreeTokens"),
                        },
                        style: {
                          backgroundColor: _vm.isRemoveButtonDisabled(
                            "sectionThreeTokens"
                          )
                            ? "#bcbec0"
                            : _vm.sections.sectionThree.sectionColour,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.updateTokens("sectionThreeTokens", -1)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "c-survey__icon c-survey__icon--minus",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass:
                          "c-survey__token-allocation-count white-text",
                      },
                      [_vm._v(_vm._s(_vm.submissionData.sectionThreeTokens))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "c-survey__token-button",
                        class: {
                          "c-survey__token-button--disabled":
                            _vm.isAddButtonDisabled,
                        },
                        style: {
                          backgroundColor: _vm.isAddButtonDisabled
                            ? "#bcbec0"
                            : _vm.sections.sectionThree.sectionColour,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.updateTokens("sectionThreeTokens", 1)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "c-survey__icon c-survey__icon--plus",
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "c-survey__token-buttons c-survey__token-buttons--desktop",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-survey__token-button",
                    class: {
                      "c-survey__token-button--disabled":
                        _vm.isRemoveButtonDisabled("sectionThreeTokens"),
                    },
                    style: {
                      backgroundColor: _vm.isRemoveButtonDisabled(
                        "sectionThreeTokens"
                      )
                        ? "#bcbec0"
                        : _vm.sections.sectionThree.sectionColour,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateTokens("sectionThreeTokens", -1)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "c-survey__icon c-survey__icon--minus",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    staticClass: "c-survey__token-allocation-count white-text",
                  },
                  [_vm._v(_vm._s(_vm.submissionData.sectionThreeTokens))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "c-survey__token-button",
                    class: {
                      "c-survey__token-button--disabled":
                        _vm.isAddButtonDisabled,
                    },
                    style: {
                      backgroundColor: _vm.isAddButtonDisabled
                        ? "#bcbec0"
                        : _vm.sections.sectionThree.sectionColour,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateTokens("sectionThreeTokens", 1)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "c-survey__icon c-survey__icon--plus",
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-survey__page-three-animation--desktop" },
          [
            _c("lottie-vue-player", {
              attrs: {
                src: _vm.pageThree.animationFile,
                "player-controls": false,
                loop: true,
                autoplay: true,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      !_vm.isNextButtonActive
        ? _c(
            "div",
            {
              staticClass:
                "c-survey__action-message c-survey__action-message--right c-survey__action-message--white",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.getRemainingTokens > 0
                      ? `Spend ${_vm.getRemainingTokens} more tokens to continue`
                      : "Spend all tokens to continue"
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-survey__actionbutton-row c-survey__actionbutton-row--right",
        },
        [
          _c("ActionButton", {
            attrs: {
              title: _vm.pageThree.prevLabel,
              buttonAction: "prev",
              arrowLeft: true,
              muted: true,
            },
          }),
          _vm._v(" "),
          _c("ActionButton", {
            attrs: {
              title: _vm.pageThree.nextLabel,
              buttonAction: "next",
              disabled: !_vm.isNextButtonActive,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-survey__page-three-animation--mobile" },
        [
          _c("lottie-vue-player", {
            attrs: {
              src: _vm.pageThree.animationFile,
              "player-controls": false,
              loop: true,
              autoplay: true,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }